<div class="container" *ngIf="survey">

  <div *ngIf="isSurveyExpired" class="d-flex justify-content-center align-items-center vh-100 bg-light">
    <div class="card shadow-lg p-4 border-0" style="max-width: 600px; width: 100%; background-color: #fff;">
      <div class="card-header text-center rounded-top py-3" style="background-color: #f8f9fa; border-bottom: 1px solid #dee2e6;">
        <h3 class="mb-0 text-dark">{{ survey.title }}</h3>
      </div>
      <div class="card-body text-center">
        <h4 class="card-title text-uppercase text-dark mb-3">Encuesta No Disponible</h4>
        <p class="card-text text-muted mb-4">{{ statusMessage }}</p>
        <button class="btn btn-dark btn-lg" (click)="redirectHome()">
          Volver a la Página Principal
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="!isSurveyExpired">
  <div class="glossary-area" *ngIf="isGlossaryAvailable()">
    <div class="glossary-image" (mouseenter)="showCompleteMessage()" (mouseleave)="hideMessage()" (click)="openGlossary()">
      <div class="speech-bubble" id="bubble">
        <span id="typingText" class="typing-text"></span>
        <span id="hoverMessage" class="hover-message">¿Necesitas aclarar algún término?</span>
      </div>
      <img src="assets/img/sv/glo_term.png" alt="Glosario de Términos">
      <div class="glossary-text">Glosario de términos</div>
    </div>

    <button class="glossary-button" (click)="openGlossaryModal()">
      <span class="glossary-label">Glosario</span>
    </button>

    <div class="modal-glosario" *ngIf="showModal">
      <div class="modal-content">
        <span class="close" (click)="closeGlossaryModal()">&times;</span>
        <div class="modal-body">
          <h2>Glosario de Términos</h2>
          <p>{{getGlossaryDetail()}}</p>
          <button class="btn btn-primary" (click)="openGlossary()">Ir al Glosario</button>
        </div>
      </div>
    </div>
  </div>


    <div class="container">
      <div class="progress">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [style.width.%]="(currentSectionIndex + 1) / visibleSections.length * 100" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>

    <form autocomplete="off">
      <div class="row div-title">
        <div class="col-sm-3 text-center">
          <img class="img-fluid logo-survey" src="/assets/img/logo.png" alt="">
        </div>
        <div class="col-sm-9" style="position: relative;">
          <div class="input-title">
            {{survey.title}}
          </div>
        </div>
        <br>
      </div>
      <div class="row">
        <div class="col-12">
          <div id="error-message" class="alert alert-warning" style="display: none;">
            <strong>¡Atención!</strong> Por favor, completa todas las preguntas obligatorias marcadas en rojo.
          </div>
          <div id="error-message" class="alert alert-warning" style="display: none;">
            <strong>¡Atención!</strong> Por favor, responde todas las preguntas obligatorias antes de finalizar la encuesta.
          </div>
          <ng-container *ngIf="survey">
            <ng-container *ngIf="visibleSections && visibleSections.length > 0">
              <div class="col-12 div-section" *ngFor="let s of visibleSections; let i = index" [hidden]="i !== currentSectionIndex">
                <h3>{{s.title}}</h3>
                <p [innerHTML]="s.summary"></p>
                <p [innerHTML]="s.detail"></p>
                <ng-container *ngFor="let q of s.questions">
                  <div class="div-question" id="question-{{q.id}}">
                    <h5>{{q.label}}
                      <i class="fa fa-exclamation-circle warning-icon" *ngIf="q.isRequired && !hasAnswer(q.id)">
                        <span class="tooltip-text">Esta es una pregunta obligatoria</span>
                      </i>
                    </h5>
                    <p [innerHTML]="q.summary"></p>
                    <p [innerHTML]="q.detail"></p>
                    <ng-container *ngIf="q.idquestiontype === 1"><!--politomica-->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-3 form-group">
                            <div class="form-check">
                              <input class="form-check-input radio" type="radio"
                                name="flexRadioDefault-{{q.id}}" id="{{o.id}}"
                                [checked]="isChecked(q.id, o.id)"
                                (click)="createAnswer(q.id, o.id, null, null, null, o.label,q.idquestiontype, null);">
                              <label class="form-check-label radio-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 9"><!--texto simple-->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-6 form-group">
                            <ng-container *ngIf="o.label.length > 0">
                              <label class="form-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </ng-container>
                            <input class="form-control" type="text" name="flexRadioDefault-{{q.id}}"
                              id="{{o.id}}"
                              [value]="getAnswer(q.id, o.id)"
                              (change)="createAnswer(q.id, o.id, null, null, null, $event.target.value,q.idquestiontype,null);">
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 7"> <!-- input numero -->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-6 form-group">
                            <ng-container *ngIf="o.label.length > 0">
                              <label class="form-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </ng-container>
                            <input class="form-control" type="number" name="flexRadioDefault-{{q.id}}"
                                  id="{{o.id}}"
                                  [value]="getAnswer(q.id, o.id)"
                                  (change)="createAnswer(q.id, o.id, null, null, null, $event.target.value,q.idquestiontype,null);"
                                  min="0" step="1" oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');">
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 13"><!-- carreras -->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-6 form-group">
                            <ng-container *ngIf="o.label.length > 0">
                              <label class="form-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </ng-container>
                            <input class="form-control" type="text" name="flexRadioDefault-{{q.id}}"
                                  id="{{o.id}}"
                                  [value]="getAnswer(q.id, o.id)"
                                  (input)="filterCareers($event.target.value, q.id, o.id)"
                                  (focus)="onFocusCareers()"
                                  (blur)="onBlurCareers()"
                                  [placeholder]="'Escribe para buscar o ingresar una nueva carrera...'">
                            <div *ngIf="isCareersDropdownVisible" class="dropdown-menu show">
                              <button *ngFor="let career of filteredCareers" class="dropdown-item"
                                      (click)="selectCareer(career, q.id, o.id)">
                                {{career.name}}
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 14"><!--paises-->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-6 form-group">
                            <ng-container *ngIf="o.label.length > 0">
                              <label class="form-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </ng-container>
                            <input class="form-control" type="text" name="flexRadioDefault-{{q.id}}"
                                  id="{{o.id}}"
                                  [value]="getAnswer(q.id, o.id)"
                                  (input)="filterCountries($event.target.value, q.id, o.id)"
                                  (focus)="onFocusCountries()"
                                  (blur)="onBlurCountries()"
                                  [placeholder]="'Escribe para buscar...'">
                            <div *ngIf="isCountriesDropdownVisible" class="dropdown-menu show">
                              <button *ngFor="let country of filteredCountries" class="dropdown-item"
                                      (click)="selectCountry(country, q.id, o.id)">
                                {{country.name}}
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 15"><!--departamentos-->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-6 form-group">
                            <ng-container *ngIf="o.label.length > 0">
                              <label class="form-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </ng-container>
                            <input class="form-control" type="text" name="flexRadioDefault-{{q.id}}"
                                  id="{{o.id}}"
                                  [value]="getAnswer(q.id, o.id)"
                                  (input)="filterStates($event.target.value, q.id, o.id)"
                                  (focus)="onFocusStates()"
                                  (blur)="onBlurStates()"
                                  [placeholder]="'Escribe para buscar...'"
                                  [disabled]="!selectedCountryId"> <!-- Deshabilitar si no se ha seleccionado un país -->
                            <div *ngIf="isStatesDropdownVisible && filteredStates.length > 0" class="dropdown-menu show">
                              <button *ngFor="let state of filteredStates" class="dropdown-item"
                                      (click)="selectState(state, q.id, o.id)">
                                {{state.name}}
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 11">
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-12 form-group">
                            <label class="form-label" for="{{o.id}}">
                              {{o.label}}
                            </label>
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col">
                                    <ng-container *ngFor="let a of o.axis">
                                      <ng-container *ngIf="a.type === 3">
                                        {{a.label}}
                                        <i *ngIf="a.detail"
                                           class="fa fa-info-circle ms-1"
                                           (click)="showDetail(a.label, a.detail)"></i>
                                      </ng-container>
                                    </ng-container>
                                  </th>
                                  <ng-container *ngFor="let a of o.axis">
                                    <ng-container *ngIf="a.type === 2">
                                      <th class="text-center position-relative" scope="col">
                                        <div class="d-inline-flex align-items-center justify-content-center">
                                          <span class="user-select-none"
                                                [class.text-primary]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                                [class.fw-semibold]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                                [class.cursor-pointer]="a.detail"
                                                [class.link-underline]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                                (click)="showDetail(a.label, a.detail)">
                                            {{a.label}}
                                            <i *ngIf="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                               class="fa fa-info-circle ms-1 align-baseline"></i>
                                          </span>
                                        </div>
                                      </th>
                                    </ng-container>
                                  </ng-container>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let a of o.axis">
                                  <ng-container *ngIf="a.type === 1">
                                    <tr id="row-{{q.id}}-{{a.id}}">
                                      <th scope="row">
                                        <span class="user-select-none"
                                                [class.text-primary]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                                [class.fw-semibold]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                                [class.cursor-pointer]="a.detail"
                                                [class.link-underline]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                                (click)="showDetail(a.label, a.detail)">
                                            {{a.label}}
                                            <i *ngIf="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                               class="fa fa-info-circle ms-1 align-baseline"></i>
                                          </span>
                                      </th>
                                      <ng-container *ngFor="let b of o.axis">
                                        <ng-container *ngIf="b.type === 2">
                                          <td class="text-center">
                                            <input class="radio" type="radio"
                                              [name]="'radio-' + q.id + '-' + a.id"
                                              [id]="o.id + '-' + b.id"
                                              [checked]="isCheckedMatrix(q.id, a.id, b.id)"
                                              (change)="createAnswer(q.id, o.id, null, a.id, b.id, b.label, q.idquestiontype,null)">
                                          </td>
                                        </ng-container>
                                      </ng-container>
                                    </tr>
                                  </ng-container>
                                </ng-container>

                              </tbody>
                            </table>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 17"><!--matriz con checkboxes-->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-12 form-group">
                            <label class="form-label" for="{{o.id}}">
                              {{o.label}}
                            </label>
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col">
                                    <ng-container *ngFor="let a of o.axis">
                                      <ng-container *ngIf="a.type === 3">
                                        {{a.label}}
                                        <i *ngIf="a.detail"
                                           class="fa fa-info-circle ms-1"
                                           (click)="showDetail(a.label, a.detail)"></i>
                                      </ng-container>
                                    </ng-container>
                                  </th>
                                  <ng-container *ngFor="let a of o.axis">
                                    <ng-container *ngIf="a.type === 2">
                                      <th class="text-center position-relative" scope="col">
                                        <div class="d-inline-flex align-items-center justify-content-center">
                                          <span class="user-select-none"
                                                [class.text-primary]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                                [class.fw-semibold]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                                [class.cursor-pointer]="a.detail"
                                                [class.link-underline]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                                (click)="showDetail(a.label, a.detail)">
                                            {{a.label}}
                                            <i *ngIf="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                               class="fa fa-info-circle ms-1 align-baseline"></i>
                                          </span>
                                        </div>
                                      </th>
                                    </ng-container>
                                  </ng-container>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let a of o.axis">
                                  <ng-container *ngIf="a.type === 1">
                                    <tr id="row-{{q.id}}-{{a.id}}">
                                      <th scope="row">
                                        <span class="user-select-none"
                                              [class.text-primary]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                              [class.fw-semibold]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                              [class.cursor-pointer]="a.detail"
                                              [class.link-underline]="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                              (click)="showDetail(a.label, a.detail)">
                                          {{a.label}}
                                          <i *ngIf="a.detail && (a.detail.length > 20 || hasHtmlTags(a.detail))"
                                             class="fa fa-info-circle ms-1 align-baseline"></i>
                                        </span>
                                      </th>
                                      <ng-container *ngFor="let b of o.axis">
                                        <ng-container *ngIf="b.type === 2">
                                          <td class="text-center">
                                            <input class="checkbox" type="checkbox"
                                              [name]="'checkbox-' + q.id + '-' + a.id"
                                              [id]="o.id + '-' + b.id"
                                              [checked]="isCheckedMatrix(q.id, a.id, b.id)"
                                              (change)="createAnswer(q.id, o.id, null, a.id, b.id, b.label, q.idquestiontype, $event.target.checked)">
                                          </td>
                                        </ng-container>
                                      </ng-container>
                                    </tr>
                                  </ng-container>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 3">
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-3 form-group">
                            <div class="form-check">
                              <input class="form-check-input checkbox" type="checkbox"
                                name="flexCheckboxDefault-{{q.id}}" id="{{o.id}}"
                                [checked]="isChecked(q.id, o.id)"
                                (change)="createAnswer(q.id, o.id, null, null, null, o.label, q.idquestiontype, $event.target.checked);">
                              <label class="form-check-label checkbox-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 16">
                      <div class="row">
                        <div class="col-12" *ngFor="let o of q.options">
                          <h2 class="title-text" [innerHTML]="o.label"></h2>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="col-4">
          <button type="button" class="btn btn-outline-primary btn-block" (click)="goToPreviousSection()" [disabled]="currentSectionIndex === 0">
            Anterior
          </button>
        </div>
        <div class="col-4">
          <button type="button" class="btn btn-outline-primary btn-block" (click)="goToNextSection()" [disabled]="currentSectionIndex === visibleSections.length - 1">
            Siguiente
          </button>
        </div>
        <div class="col-4">
          <button type="button" class="btn btn-primary btn-block" (click)="confirmFinalizarEncuesta()" *ngIf="currentSectionIndex === visibleSections.length - 1">
            Finalizar
          </button>
        </div>
      </div>
    </form>

    <!-- Modal de agradecimiento -->
    <div id="thankYouModal" class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Gracias por completar la encuesta</h5>
          </div>
          <div class="modal-body">
            <p>Apreciamos mucho tu participación. ¡Gracias por tu tiempo y valioso aporte!</p>
            <p>Te invitamos a compartir esta encuesta con tus colegas. ¡Su opinión es fundamental!</p>
            <input id="surveyUrl" type="text" class="form-control mb-3" readonly [value]="currentUrl">
            <button class="btn btn-secondary" (click)="copyToClipboard()">Copiar enlace</button>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="redirectHome()">Ir al inicio</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal matriz paso a paso -->
    <div class="modal" id="detailModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{modalTitle}}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div [innerHTML]="safeHtmlContent"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

  <ng-container *ngIf="!hiddenMsg">
    <app-alert [message]="msg.message" [status]="msg.status"></app-alert>
  </ng-container>
</div>
